import { CalendarHoliday } from './parseIcsHolidays';

const getHolidayDateKey = (holiday: CalendarHoliday) => `${holiday.month}-${holiday.day}`;

const withoutExistingDates = (
    existing: CalendarHoliday[],
    imported: CalendarHoliday[],
) => {
    const dates = new Set(existing.map(getHolidayDateKey));
    return imported.filter((holiday) => {
        const key = getHolidayDateKey(holiday);
        if (dates.has(key)) return false;
        dates.add(key);
        return true;
    });
};

export default withoutExistingDates;
